export default __webpack_public_path__ + "static/media/Icon awesome-twitter.860e36fb.svg";